<template>
    <div>
        <div class="row">
            <div v-if="ready">
                <div v-if="fields" class="col-md-6 ">
                    <div v-if="fields.title">
                  <h3><a :href="fields.address_normalized" target="_blank">{{fields.title}}</a></h3>
                    </div>
                  <ul>
                    <li>
                        URL: <a :href="fields.address_normalized" target="_blank">{{fields.address_normalized}}</a>
                    </li>
                    <li v-if="preview_template">
                      Preview Link: <a :href="'/preview/'+extent_id+'/'+fields.processed_asset_id" target="_blank">{{preview_template.name}} template</a>
                    </li>
                    <li v-if="preview_template">
                      Migration JSON: <a :href="'/migration/assets/'+extent_id+'/'+fields.processed_asset_id" target="_blank">JSON</a>
                    </li>
                  </ul>
                    <p v-if="import_date">Imported on {{import_date}}</p>
                  <div v-if="metadata.manual_values && metadata.manual_values.simplified && metadata.manual_values.simplified.length > 0" style="padding-bottom:30px;">
                    <h4>Overridable Fields</h4>
                    <div v-for="field in metadata.manual_values.simplified" style="padding:15px;margin-bottom:8px;border:1px solid gray">
                      <manual-field-editor :field_prop="field" :extent_id="extent_id" :asset_id="asset_id" asset_type="App\ProcessedAsset"/>
                    </div>
                  </div>
                    <div v-if="show_overrides && assignment" style="margin-bottom:20px;">
                        <table style="background-color:#eeeeee;border:1px solid black;padding:5px;">
                            <tr>
                                <th style="padding:5px;">Bucket</th>
                                <th style="padding:5px;">Disposition</th>
                                <th style="padding:5px;">Resourcing</th>
                            </tr>
                            <tr>
                                <td style="padding:5px;">{{assignment.bucket}}</td>
                                <td style="padding:5px;">{{assignment.disposition}}</td>
                                <td style="padding:5px;">{{assignment.resourcing}}</td>
                            </tr>
                        </table>
                        <p>{{assignment_text}}</p>
                    </div>
                    <div v-else-if="show_overrides" style="margin-bottom:20px;">{{assignment_text}}</div>
                    <div v-if="show_history && history && history.raw_all!==[]">
                        History:
                        <el-select filterable v-model="selected_chain" value-key="job_chain.id" placeholder="">
                            <el-option
                                    v-for="raw in history.raw_all"
                                    :label = "raw.job_chain.job_chain_type.name + ' ' + raw.clean_date + ' ' + (raw.en_pos ? '(' + raw.en_pos + ')' : '') "
                                    :value = "raw.job_chain.id">
                            </el-option>
                        </el-select>
                        <el-button v-if="selected_chain" @click="go_most_recent">Go to most recent</el-button>
                    </div>
                    <p style="color:red">{{data_version_error}}</p>

                    <a :href="'/assetdetails/' + extent_id + '/' + asset_id" target="_blank">Edit in new tab</a>
                    <div style="margin-top: 30px;">
                        <a :href="annotate_url" target="_blank">Annotate</a>
                        <h4>Fields available to graphing and rules</h4>
                        <ul>
                            <li v-for="(value, key) in fields" v-if="key!='screenshots'">
                              <span v-if="
                                key==='address_original' ||
                                key==='address_normalized' ||
                                key==='example_url_in'
                              ">
                               {{ key}}:
                               <a :href="value" target="_blank">{{value}}</a>
                              </span>
                              <span v-else>
                                {{ key}}: {{ value }}
                              </span>
                            </li>
                        </ul>
                    </div>
                    <div v-if="show_slow && slow_info" style="margin-top: 30px;">
                        <h4>Other information</h4>
                        <div v-if="slow_info.asset_urls && slow_info.asset_urls.image_srcs">
                            <h5>Images</h5>
                            <ul>
                                <li v-for="url in slow_info.asset_urls.image_srcs">
                                    {{url}}
                                </li>
                            </ul>
                        </div>
                        <div v-if="slow_info.linkages && slow_info.linkages.inbound">
                            <h5>Links In</h5>
                            <ul>
                                <li v-for="url in slow_info.linkages.inbound">
                                    <a :href="url" target="_blank">{{url}}</a>
                                </li>
                            </ul>
                        </div>
                        <div v-if="slow_info.linkages && slow_info.linkages.outbound">
                            <h5>Links Out</h5>
                            <ul>
                                <li v-for="url in slow_info.linkages.outbound">
                                  <a :href="url" target="_blank">{{url}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div v-if="show_screenshots" class="col-md-6 ">
                    <div v-if="metadata.screenshots">
                        <div v-for="screenshot in metadata.screenshots" style="margin-bottom:20px;">
                            <a :href="screenshot.public_url" target="_blank">
                              <img style="border: 1px solid gray;padding: 2px;" :width="screenshot.display_percent" :src="screenshot.public_url" />
                            </a>
                            <div>
                              {{screenshot.name}}
                              <el-popover
                                  placement="top-start"
                                  :title="screenshot.name"
                                  width="300"
                                  trigger="hover"
                                  :content="info(screenshot)"
                              >
                                <i class="el-icon-info" slot="reference"></i>
                              </el-popover>
                            </div>
                        </div>
                    </div>
                    <div v-else style="padding: 0px 50px 0px 70px;color:lightgray;" v-html="no_screenshot_text">

                    </div>
                  <div v-if="metadata.components">
                    <h2>Components on Page</h2>
                    <div v-for="component_type in metadata.components">
                        <h3>
                            {{component_type.definition.name}}
                        </h3>
                        <ol>
                          <li v-for="component in component_type.components">
                            <a :href="component.link">{{component.raw_value}}</a>
                          </li>
                        </ol>
                    </div>
                  </div>
                </div>
            </div>
            <div v-else style="margin-left: 50px;">Loading data</div>
        </div>
    </div>

</template>

<script>
    import ManualFieldEditor from "./ManualFieldEditor";
    export default {
      components: {ManualFieldEditor},
      props: ['asset_id','extent_id'],
        mounted() {
            console.log('mounted AssetDetail')
            this.get_asset_metadata()
            this.get_history()
            if (chimera.features.includes('screenshots')) this.show_screenshots = true
            if (chimera.features.includes('over_time')) this.show_history = true
            if (chimera.features.includes('slow_info')) this.show_slow = true
            if (chimera.features.includes('override_assignments')) this.show_overrides = true
        },
        data() {
            return {
                preview_template: null,
                metadata: null,

                show_slow: false,
                show_screenshots: false,
                show_history: false,
                show_overrides: false,

                history: null,
                selected_chain: null,
                slow_info: null,
                assignment: null,

                ready: false,
                data_version_error: '',
                awaiting_screenshot: false,
            }
        },
        watch: {
            selected_chain: function() {
                this.get_asset_metadata()
            },
            asset_id: function() {
              this.get_asset_metadata()
            }
        },
        computed: {
            annotate_url: function() {
              return "/annotations/" + this.extent_id + "?url=" + (this.fields.address_original ? this.fields.address_original : this.fields.address_normalized)
            },
            import_date: function () {
                if (this.show_history) {
                    if (this.selected_chain && this.history && this.history.raw_all) {
                        return this.history.raw_all.find((raw) => raw.job_chain.id === this.selected_chain).crawl_time;
                    } else if (this.history) {
                        return this.history.last_encountered
                    } else {
                        return null
                    }
                } else {
                    return null
                }
            },
            assignment_text: function() {
              if (this.assignment) {
                  return this.assignment.method
              } else {
                  return 'No assignment'
              }
            },
          no_screenshot_text: function() {
              if (this.awaiting_screenshot) {
                return "<p>Just now requested a new screenshot. If it takes less than ten seconds, the new screenshot will appear here soon.</p>"
              } else {
                return "<p>No screenshots:  </p> <ul> <li>If you recently crawled the site, you may have to wait before seeing any screenshots.</li>  <li>Only the first pages of a crawl receive screenshots.</li><li>Screenshots is a new feature, so an older site will not have screenshots unless you recrawl.</li> <li>URLs that were imported without crawling will not show screenshots.</li> <li>An archived site will no longer show screenshots.</li> </ul>"
              }
          }
        },
        methods: {
            info(screenshot) {
              return 'Screenshot taken ' + screenshot.timestamp_pretty +
                  ' with dimensions ' + screenshot.size.width + 'x' + screenshot.size.height +
                  '. It took ' + screenshot.duration_in_seconds + ' seconds to take the screenshot.';
            },
            screenshot_adhoc(address,address_hash) {
              this.awaiting_screenshot = true
              axios.post('/api/screenshot/adhoc/' + this.extent_id, {
                    address: address,
                    address_hash: address_hash
                  })
                  .then(response => {
                    console.log('added job to the queue')

                    setTimeout(() => {
                      console.log('going to now request metadata again')
                      this.get_asset_metadata(1)
                      this.awaiting_screenshot = false
                    }, 10 * 1000); // 10 seconds
                  })
                  .catch(error => {
                    this.awaiting_screenshot = false
                    console.log('oops could not seem to post to do an ad hoc screenshot')
                  })
            },
            get_asset_metadata(pass=0) {
                if (pass===0) {
                  this.metadata = null
                  this.fields = null
                  this.prevew_template = null
                }
                this.ready = false
                this.data_version_error = ''
                let endPoint = '/api/assets/' + this.extent_id + '/' + this.asset_id
                endPoint = endPoint + (this.selected_chain ? '?data_import_id=' + this.selected_chain : '')
                axios.get(endPoint)
                    .then(response => {
                        this.metadata = response.data
                        this.preview_template = response.data.preview_template
                        this.fields = this.metadata.fields
                        if (this.metadata.screenshots) {
                            console.log('have screenshots')
                        } else {
                          if (this.show_screenshots && pass===0) {
                            this.screenshot_adhoc(this.metadata.address_original,this.metadata.address_hash)
                          }
                        }
                        if (pass===0) {
                          if (this.metadata.slow_info) {
                            this.slow_info = this.metadata.slow_info
                            delete this.metadata.slow_info
                          }
                          if (this.metadata.assignment) {
                            this.assignment = this.metadata.assignment
                            delete this.metadata.assignment
                          }
                        }
                        this.ready = true
                    })
                    .catch(error => {
                        if (this.selected_chain) {
                            this.data_version_error = 'Detailed data not available for that timestamp'
                        } else {
                            this.data_version_error = 'Data not available'
                        }
                        console.log("oops getting asset metadata")
                    })
            },
            get_history() {
                console.log('about to try getting the history')
                axios.get('/extents/search_processed_asset_id/' + this.extent_id + "?processed_asset_id=" + this.asset_id)
                    .then(response => {
                        this.history = response.data
                    })
                    .catch(error => {
                        console.log("oops getting history")
                    })
            },
            go_most_recent() {
                this.selected_chain = null
            }
        }
    }

</script>
